import $ from 'jquery';
import { debounce } from 'lodash';

/**
 * @desc We can't style form select so we hide original select and show custom dropdown instead
 */
export default class MCDropdown {
  /**
   * @param {object} options
   * @param {string} options.dropdownSelector
   * @param {string} options.btnSelector
   * @param {string} options.listSelector
   * @param {string} options.itemSelector
   * @param {string} options.selectSelector
   */
  constructor({
    dropdownSelector,
    btnSelector,
    listSelector,
    btnTextSelector,
    selectSelector,
  } = {}) {
    this.$dropdown = $(dropdownSelector);
    this.$btn = $(btnSelector);
    this.$list = $(listSelector);
    this.dropdownSelector = dropdownSelector;
    this.btnSelector = btnSelector;
    this.listSelector = listSelector;
    this.btnTextSelector = btnTextSelector;
    this.selectSelector = selectSelector;
    this.openClass = 'open';
    this.selectedClass = 'selected';
    this.$searchInput = $('.js-dropdown-search');
    this.$btnClearInput = $('.js-dropdown-clear-search');

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$btn.length) {
      this.isInitialized = false;

      return;
    }

    this.attachEventListeners();
  }

  attachEventListeners() {
    /* close all dropdowns and open current */
    this.$btn.on('click', (elem) => {
      elem.preventDefault();
      elem.stopPropagation();
      const $this = $(elem.target);
      const isOpen = $this.parent().hasClass(this.openClass);
      /* close all opened dropdown */
      this.$dropdown.removeClass(this.openClass);
      this.$searchInput.val('').hide();
      this.$list.find('li').show();
      this.$btnClearInput.hide();
      this.$btn.attr('aria-expanded', 'false');
      if (!isOpen) {
        if ($this.parent().find(this.listSelector).find('li').length > 10) {
          $this.parent().find('.js-dropdown-search').show();
        }

        $this.parent().addClass(this.openClass);
        $this.attr('aria-expanded', 'true');
      }
    });

     this.$dropdown.on('keydown', (elem) => {
        if (elem.which === 13) {
            elem.preventDefault();
            this.$dropdown.addClass(this.openClass);

            // @todo: add other keys support
        }
    });

    this.$dropdown.on('click', 'li', (elem) => { this.selectItem(elem); });

    this.$searchInput.on('click', (elem) => { elem.stopPropagation(); });

    this.$searchInput.on('keyup', debounce((elem) => this.filterDropdown(elem), 500));

    /* close all opened dropdowns when click on any element outside dropdown */
    $(document).on('click', () => {
      this.$dropdown.removeClass(this.openClass);
      this.$searchInput.val('').hide();
      this.$list.find('li').show();
      this.$btnClearInput.hide();
    });

    this.$btnClearInput.on('click', (elem) => {
      elem.stopPropagation();

      const $this = $(elem.target);

      $this.parent().find('.js-dropdown-search').val('');
      $this.parent().find(this.listSelector).find('li').show();
      $this.hide();
    });
  }

  /**
   * @desc select new item in dropdown and select
  */
  selectItem(elem) {
    elem.stopPropagation();
    const $this = $(elem.target).closest('li');
    const text = $this.html();
    const val = $this.data('val');

    /* change text in btn */
    $this.parents(this.dropdownSelector).find(this.btnSelector).find(this.btnTextSelector).html(text);
    /* remove selected class from list */
    $this.parent().find(`.${this.selectedClass}`).removeClass(this.selectedClass);
    /* mark new item as selected */
    $this.addClass(this.selectedClass);
    /* close dropdown */
    $this.parents(this.dropdownSelector).removeClass(this.openClass);
    $this.parents(this.dropdownSelector).find('.js-dropdown-search').val('').hide();
    $this.parents(this.dropdownSelector).find(this.listSelector).find('li').show();
    $this.parents(this.dropdownSelector).find('.js-dropdown-clear-search').hide();
    /* select new option in select for form submit */
    $this.parents(this.dropdownSelector).find(this.selectSelector).val(val);
    /* trigger change event */
    $this.parents(this.dropdownSelector).find(this.selectSelector).trigger('mc-dropdown:change');
    $this.parents(this.dropdownSelector).find(this.selectSelector).trigger('change');

    /* dispatch native event for new umbraco forms script */
    const event = new Event('change');
    $this.parents(this.dropdownSelector).find(this.selectSelector).get(0).dispatchEvent(event);
  }

  filterDropdown(elem) {
    const $this = $(elem.target);
    const searchText = $this.val();

    if (searchText) {
      this.$btnClearInput.show();
    } else {
      this.$btnClearInput.hide();
    }

    $this.parent().find(this.listSelector).find('li')
      .toArray()
      .map((item) => {
        if ($(item).text().toLowerCase().includes(searchText.toLowerCase())) {
          $(item).show();
        } else {
          $(item).hide();
        }
        return true;
      });
  }
}
